<template>
  <aside v-if="computedValue" class="modal">
    <SvoiModalContent :size="size" @out-click="onClose">
      <template #header>
        <slot name="header" />
      </template>

      <slot />

      <template #close>
        <slot name="close">
          <SvoiIcon class="close" icon="essential/xmark-clear" size="m" @click="onClose" />
        </slot>
      </template>
    </SvoiModalContent>
  </aside>
</template>

<script lang="ts">
import { ComponentPropsOptions, computed, defineComponent, isVue2, PropType } from 'vue-demi'
import { isString } from '@svoi-ui/shared/utils/guards'
import { SvoiIcon } from '@svoi-ui/components/icon'
import { ModalSizes } from '@svoi-ui/interfaces/modal'
import { SvoiModalContent } from './'

const modelProp: ComponentPropsOptions = isVue2
  ? {
      value: {
        type: Boolean,
        required: true
      }
    }
  : {
      modelValue: {
        type: Boolean,
        required: true
      }
    }

export default defineComponent({
  name: 'SvoiModal',
  components: { SvoiIcon, SvoiModalContent },
  props: {
    ...modelProp,
    size: {
      type: String as PropType<ModalSizes>,
      default: ModalSizes.md,
      validator: (value: unknown) => {
        return (
          isString(value) &&
          [
            ModalSizes.full.toString(),
            ModalSizes.md.toString(),
            ModalSizes.sm.toString(),
            ModalSizes.lg.toString()
          ].includes(value)
        )
      }
    }
  },
  emits: ['input', 'on-close', 'update:modelValue'],
  setup(props, { emit }) {
    const computedValue = computed({
      get() {
        // @ts-expect-error
        return isVue2 ? props.value : props.modelValue
      },
      set(val) {
        emit(isVue2 ? 'input' : 'update:modelValue', val)
      }
    })

    const onClose = () => {
      emit('on-close')

      computedValue.value = false
    }

    return { computedValue, onClose }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/modal/modal';
</style>
